var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"28","cy":"28","r":"28","fill":"#5668F1","key":0}),React.createElement("path",{"d":"M28.4512 15.5908C28.712 15.2035 29.2062 15.0482 29.6416 15.2168C30.077 15.3854 30.3375 15.833 30.2695 16.2949L28.9756 25.0693H35.5C35.8666 25.0693 36.2039 25.2697 36.3789 25.5918C36.5538 25.914 36.5386 26.3068 36.3389 26.6143L27.1924 40.6943C26.9411 41.0811 26.4577 41.2456 26.0225 41.0928C25.5872 40.9398 25.3125 40.5089 25.3584 40.0498L26.3457 30.1895H20.5C20.1304 30.1895 19.7908 29.9855 19.6172 29.6592C19.4436 29.3329 19.4645 28.9374 19.6709 28.6309L28.4512 15.5908Z","stroke":"#EBECF7","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Clear.defaultProps = {"width":"56","height":"56","viewBox":"0 0 56 56","fill":"none"};

module.exports = Clear;

Clear.default = Clear;
